export const formatTime = (strTime: string) => {
  if (!strTime) {
    return strTime;
  }
  const time = strTime.split(":");
  return `${time[0]}:${time[1]}`;
};

export const getDateFromString = (strTime: string) => {
  if (!strTime) {
    return strTime;
  }
  const date = new Date(strTime);
  return `${date.getUTCDate()}/${date.getUTCMonth() + 1}`;
};

export const getDateFromStringYear = (strTime: string) => {
  if (!strTime) {
    return strTime;
  }
  const date = new Date(strTime);
  const year = date.getUTCFullYear().toString().slice(-2);
  return `${date.getUTCDate()}/${date.getUTCMonth() + 1}/${year}`;
};

export const getMonthFullName = (minus = 0) => {
  const date = new Date();
  date.setDate(1);
  date.setMonth(date.getMonth() - minus);
  const month = date.toLocaleString("default", { month: "long" });
  return month;
};

export const getMonthDateString = (minus = 2) => {
  const date = new Date();
  // Go 2 months back
  date.setMonth(date.getMonth() - minus);

  // Format to YYYY-MM
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed

  return `${year}-${month}`;
};

export const msToTime = (duration: number) => {
  if (!duration) {
    return duration;
  }
  const seconds = duration / 1000;
  const minutes = seconds / 60;
  const hours = minutes / 60;
  return Math.floor(hours * 100) / 100;
};

export const getDaysInMonth = (month: number, year: number) =>
  // gets last date of last month
  new Date(year, month + 1, 0).getDate();

export const getWorkingDays = (month: number, year: number) => {
  const date = new Date(year, month);
  let numOfWorkingDays = 0;
  while (date.getMonth() === month) {
    // Exclude weekends
    const tempDate = new Date(date).getDay();

    if (tempDate % 7 !== 0) {
      numOfWorkingDays += 1;
    }
    date.setDate(date.getDate() + 1);
  }
  return numOfWorkingDays;
};

export const getAttendanceDay = (dateValue: string) => {
  const date = new Date(dateValue);
  return Number.isNaN(date.getTime()) ? null : date.getUTCDate();
};

export const isAttendanceSunday = (dateValue: string) => {
  const date = new Date(dateValue);
  return !Number.isNaN(date.getTime()) && date.getUTCDay() === 0;
};
